module.exports = __webpack_public_path__ + "static/media/S (161).474fd759.jpg";